import React from 'react';
import {ModalBox, ModalContainer, SubTitle, Title} from '../Style/MoveNextClassModal.style';
import nextClassIcon from '../../../images/move_class.png';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import utilService from '../../../services/utilService';
import {MAX_LEN_CLASS_NAME} from '../Config/MoveNextClassModal.constants';

const MoveNextClassModal = ({open, className}) => (
    <ModalContainer open={open}>
        <>
            <ModalBox>
                <img alt='next_class_image' src={nextClassIcon} width={64} height='auto' />
                <Title>{_SYSTEM_TITLES.manualRefinementDone}</Title>
                <SubTitle>{_SYSTEM_TITLES.moveToAnotherClassBeforeClassTitle}</SubTitle>
                <SubTitle>{`${utilService.normalizedSting(className, MAX_LEN_CLASS_NAME)}`}</SubTitle>
            </ModalBox>
        </>
    </ModalContainer>
);

export default MoveNextClassModal;
